import { Component, Output, EventEmitter, ViewChildren, QueryList, AfterViewInit, OnDestroy, ContentChildren, Input } from '@angular/core';
import { TabComponent } from '../tab/tab.component';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
    selector: 'tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    standalone: false
})
export class TabsComponent implements AfterViewInit, OnDestroy {

  @Output() onTabChange: EventEmitter<any> = new EventEmitter();
  tabs: TabComponent[] = [];

  @ContentChildren(TabComponent)
  public tabsQuery: QueryList<TabComponent>;

  private _selectedTab: TabComponent;

  private tabsSubscription: Subscription;

  ngAfterViewInit(): void {
    this.tabsQuery.changes.subscribe(() => {
      this.onTabCollectionChanged(false);
    });

    setTimeout(() => this.onTabCollectionChanged(true));
  }

  ngOnDestroy(): void {
    if (this.tabsSubscription) {
      this.tabsSubscription.unsubscribe();
    }
  }

  // addTab(tab: TabComponent) {
  //   if (this.tabs.length === 0) {
  //     tab.active = true;
  //   }
  //   this.tabs.push(tab);
  // }

  selectTab(tab: TabComponent) {
    this.tabs.forEach(tab => {
      tab.active = false;
    });
    tab.active = true;
    this._selectedTab = tab;
    this.onTabChange.emit();
  }

  selectTabByIndex(index: number) {
    this.tabs.forEach((tab, i) => {
      if (i == index) {
        tab.active = true;
      }
      else {
        tab.active = false;
      }
    });
  }

  private onTabCollectionChanged(isInitial: boolean) {
    this.tabs = this.tabsQuery.map(x => x);

    if (isInitial) {
      this._selectedTab = this.tabs.find(x => x.active);
    }


    if (this.tabs.length > 0 && (!this._selectedTab || this.tabs.indexOf(this._selectedTab) < 0)) {
      this.selectTabByIndex(0);
    }
  }
}
